import {
  Card,
  HStack,
  VStack,
  Text,
  Badge as GSBadge
} from "@gluestack-ui/themed";

import { ProposalCardProps } from "./types";
import { Badge } from "@repo/core/components/core/Badge";
import { BadgeText } from "@gluestack-ui/themed";

import { useDimensions } from "@repo/core/hooks/useDimensions";
import { StatusBadge } from "@repo/core/constants/proposals";
import { ProposalCardStatusEnum } from "@repo/core/enums/proposals";

/**
 * Gets the status badge text, prioritizing API description when available
 */
const getStatusBadgeText = (
  status: ProposalCardStatusEnum,
  statusCode?: string,
  statusDescription?: string
): string => {
  // Check if we have both statusCode and statusDescription (not empty strings)
  if (
    statusCode &&
    statusDescription &&
    statusCode.trim() !== "" &&
    statusDescription.trim() !== ""
  ) {
    // Normalize code to always have 2 digits
    const normalizedCode =
      statusCode.length === 1 ? `0${statusCode}` : statusCode;
    return `${normalizedCode} - ${statusDescription}`;
  }
  // Fallback to current system
  return (
    StatusBadge[status]?.text ||
    StatusBadge[ProposalCardStatusEnum.IN_PROGRESS].text
  );
};

export const ProposalCard = ({
  name,
  type,
  cardName,
  proposalId,
  status,
  statusCode,
  statusDescription
}: ProposalCardProps) => {
  const { width } = useDimensions();

  const cardWidth = width >= 768 ? 378 : width - width * 0.2;

  return (
    <Card w={cardWidth} mr="$4" flexWrap="wrap">
      <VStack alignItems="flex-start">
        <HStack>
          <Badge
            type={StatusBadge[status].type}
            text={getStatusBadgeText(status, statusCode, statusDescription)}
          />
        </HStack>
        <HStack mt="$4" alignItems="center">
          <GSBadge
            action="muted"
            size="sm"
            py="$1"
            px="$2"
            mr="$2"
            bgColor="$backgroundLight100"
            borderRadius="$sm"
          >
            <BadgeText fontWeight={500} fontSize="$xs">
              {proposalId}
            </BadgeText>
          </GSBadge>
          <Text size="sm" fontWeight={600} color="$textDark">
            {name.length > 22 ? `${name.slice(0, 22)}...` : name}
          </Text>
        </HStack>
        <HStack alignItems="center" mt="$2">
          <Text fontSize="$xs" fontWeight={700} color="$textLight600">
            {type ? `${type} •` : ""}{" "}
          </Text>
          <Text fontSize="$xs" fontWeight={400} color="$textLight700">
            {cardName}
          </Text>
        </HStack>
      </VStack>
    </Card>
  );
};
